import React, { Component } from 'react';

//Custom Components
import Header from '../components/Header'
import SingleAppShowCase from '../components/SingleAppShowcase'
import Hero from '../components/Hero'

// Image for Hero
import invoHero from '../img/invo_hero.png'

// Images for Demo
// import invosc from '../img/invo-screenshot.png'
import invosc from '../img/optimized/invoOverview.webp'
import invoRem from '../img/invoRemember.png'
import invoDark from '../img/invoDarkMode.png'
import invoScheduling from '../img/invoScheduling.png'
import inCallMessaging from '../img/inCallMessaging.png'
import coBrowsing from '../img/coBrowsing.png'

// Company Logo
import invoLogo from '../img/invo-logo.png'

class Invo extends Component {
  componentDidMount() {
    window.scrollTo(0, 0)
  }
  render() {
    return (
    <div
      className="align-items-center invo-background"
      style={{backgroundColor:'#1E1E1E'}}
    >
        <Header
            title="Invo Solutions"
            backgroundColor={'#337DF2'}
            textColor={'#FFF'}
            jobTitle={'Software Engineer I'}
            yearsAtRole={"2020-2021"}
        /> 
        <Hero
            heroBackground={invoHero}
            jobTitle={"Software Engineer I"}
            companyName={"Invo Solutions"}
            yearsActive={"2020 - 2021"}
        />


      <SingleAppShowCase
            backgroundColor={'#1E1E1E'}
            addClass="invo-background"
            // appTitle={"Invo GO"}
            logoWidth={'75%'}
            appLogo={invoLogo}
            extraPadding={'25%'}
            appDescription="At Invo Solutions, I led the complete rebuild of our mobile video banking platform using React Native, 
            creating a unified codebase shared across multiple financial institutions. I designed a modern, intuitive user interface 
            and introduced a range of new features that significantly improved usability and performance. 
            The redesigned app has already driven several new sales, even ahead of its beta launch in Q4 2021." 
            mirrored={true}
            appVisual={invosc}
            lightText={true}
        />  

        <h2 class="mid-page-heading-dark-bg">New Features</h2>

        <SingleAppShowCase
            backgroundColor={'#1E1E1E'}
            addClass="invo-background"
            appTitle={"Save User Profiles"}
            extraPadding={'15%'}
            appDescription="Using secure local storage, the app safely retains your email, phone number, 
            and past conversations with your financial institution — making future interactions faster and more personalized"
            appVisual={invoRem}
            lightText={true}
        />  
          <SingleAppShowCase
            backgroundColor={'#1E1E1E'}
            addClass="invo-background"
            appTitle={"Dynamic Theme Switching"}
            extraPadding={'5%'}
            appDescription="Whether users prefer light mode or dark mode, 
            the app follows their device settings to deliver a consistent experience. 
            Each screen has been thoughtfully designed to meet ADA accessibility standards across both themes."
            appVisual={invoDark}
            mirrored={true}
            lightText={true}
        /> 
        <SingleAppShowCase
            backgroundColor={'#1E1E1E'}
            addClass="invo-background"
            appTitle={"Appointment Scheduling"}
            extraPadding={'15%'}
            appDescription="The app leverages a custom scheduling API to retrieve real-time availability from the user's financial institution, 
            allowing users to easily select open appointment slots with their tellers. 
            When it’s time for their scheduled appointment, users receive a push notification prompting them to join the call."
            appVisual={invoScheduling}
            lightText={true}
        /> 
        <SingleAppShowCase
            backgroundColor={'#1E1E1E'}
            addClass="invo-background"
            // appTitle={"Invo"}
            appTitle={"In Call Messaging"}
            extraPadding={'5%'}
            appDescription="Enjoy peace of mind while connecting with your teller using encrypted video, VOIP, or text messaging — ensuring your personal information stays protected."
            appVisual={inCallMessaging}
            mirrored={true}
            lightText={true}
        />  
          <SingleAppShowCase
            backgroundColor={'#1E1E1E'}
            addClass="invo-background"
            // appTitle={"Invo"}
            appTitle={"Co-Browse"}
            extraPadding={'5%'}
            appDescription="With your permission, your financial institution can securely 
            join your web session to collaborate on documents, 
            answer questions, and guide you step-by-step toward your financial goals."
            appVisual={coBrowsing}
            
            lightText={true}
        />  
    </div>
    );
  }
}

export default Invo;



// WEBPACK FOOTER //
// ./src/screens/Invo.js